import { Button } from '@mui/material'

const UiButton = ({ children, variantType, ...props }) => {
  const styles = {
    prev: {
      backgroundColor: 'white',
      color: 'content.primary',
      border: '1px solid #F6F6F6',
      '&:hover': {
        backgroundColor: '#F6F6F6'
      }
    },
    next: {
      backgroundColor: 'primary',
      color: 'red'
    },
    cancel: {
      backgroundColor: 'white',
      color: 'content.primary',
      border: '1px solid',
      borderColor: 'border.primary',
      height: '40px',
      '&:hover': {
        backgroundColor: '#F6F6F6'
      }
    },
    quit: {
      height: '40px',
      backgroundColor: 'error.main',
      '&:hover': {
        backgroundColor: 'error.secondary'
      }
    }
  }

  const buttonStyles = styles[variantType] || {}

  return (
    <Button
      {...props}
      sx={{
        fontWeight: 500,
        minHeight: '32px',
        height: '44px',
        borderRadius: '8px',
        '&.Mui-disabled': {
          backgroundColor: 'transparent'
        },
        ...buttonStyles,
        ...props.sx
      }}
      variant="contained">
      {children}
    </Button>
  )
}

export default UiButton
